const Reducer = (state, action) => {
  switch (action.type) {
    case "SET_ACTIVE_SECTION":
      const active_id = action.payload.id;
      let old_sections = [...state.sections];
      old_sections.forEach((section) => {
        if (section.id === active_id) {
          section.active = true;
        } else {
          section.active = false;
        }
      });
      return {
        ...state,
        sections: old_sections,
      };
    case "SET_SINGLE_POSITION":
      const id2 = action.payload.id;
      const pos2 = action.payload.pos;
      let old_sections2 = [...state.sections];
      old_sections2.forEach((section) => {
        if (section.id === id2) {
          section.pos = pos2;
        }
      });
      return {
        ...state,
        sections: old_sections2,
      };

    default:
      return state;
  }
};

export default Reducer;
